import React, { ComponentProps } from "react";
import { Icon } from "../icon";
import { TransparentButton } from "../transparent-button";

/** Accept button used in ConfirmationBar */
export const ConfirmationBarAcceptButton = (props: ComponentProps<typeof TransparentButton>) => (
	<TransparentButton {...props}>
		<Icon iconName="check" />
	</TransparentButton>
);
